<template>
  <div>
    <p class="font-bold mb-5">What's your current business type?</p>
    <div class="w-full flex flex-col justify-around">
      <RouterLink to="/business-lookup" class="card mb-3 gtm-customer-type">
        <DrIcon svg="save-file" scale class="h-12" />
        <div class="ml-6 pl-1">Limited company</div>
      </RouterLink>
      <RouterLink to="/business-lookup" class="card mb-3 gtm-customer-type">
        <DrIcon svg="conference" scale class="h-12" />
        <div class="ml-6 pl-1">Partnership</div>
      </RouterLink>
      <a class="card gtm-customer-type" data-cy="btn-sole-trader" @click="goToActivities">
        <DrIcon svg="men" scale class="h-12" />
        <div class="ml-6 pl-1">Sole trader</div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    businessName: {
      get () {
        return this.$store.getters.getBusinessName
      },
      set (value) {
        this.$store.commit('updateBusinessName', value)
      },
    },
    businessNumber: {
      get () {
        return this.$store.getters.getBusinessNumber
      },
      set (value) {
        this.$store.commit('updateBusinessNumber', value)
      },
    },
    isValidBusiness: {
      get () {
        return this.$store.getters.getIsValidBusiness
      },
      set (value) {
        this.$store.commit('updateIsValidBusiness', value)
      },
    },
    firstName: {
      get () {
        return this.$store.getters.getFirstName
      },
      set (value) {
        this.$store.commit('updateFirstName', value)
      },
    },
    lastName: {
      get () {
        return this.$store.getters.getLastName
      },
      set (value) {
        this.$store.commit('updateLastName', value)
      },
    },
  },
  watch: {
    businessNumber (newVal) {
      if (newVal && !this.$store.state.portal) this.goToActivities()
    },
  },
  methods: {
    goToActivities () {
      this.businessName = ''
      this.businessNumber = ''
      this.isValidBusiness = false
      this.firstName = ''
      this.lastName = ''
      this.$router.push('/business-activities')
    },
  },
}
</script>

<style scoped>
.card {
  transition: all 0.3s;

  @apply shadow border bg-white rounded p-6 pr-4 w-full text-center cursor-pointer flex items-center border-grey-150 no-underline;
}

.card svg {
  @apply text-blue-500;
}

.card:hover {
  @apply text-white bg-blue-500 border-blue-600;
}

.card:hover svg {
  @apply text-white;
}
</style>
